import { ReactNode } from 'react';

type Props = {
	children: ReactNode;
};

const AIInterviewLayout = ({ children }: Props) => {
	return <div className="grid grid-rows-[60px_calc(100vh-140px)_80px]">{children}</div>;
};

export default AIInterviewLayout;
